import { V1GetSubscriptionAvailabilitiesResponse } from "../../communicationTypes";

export default class StyleSubscriptionAvailabilityService {
  async getAvailability(params: { styleCode: string; tiers?: string[]; startDate?: string; endDate?: string }) {
    const { styleCode, tiers, startDate, endDate } = params;
    let dateRangeQuery = "";
    if (startDate && endDate) {
      dateRangeQuery = `&start_date=${startDate}&end_date=${endDate}`;
    }
    const tiersParam = tiers ? `&tiers=${tiers.join(",")}` : "";

    const response = await fetch(
      `/api/v1/subscription-availabilities?style_codes=${styleCode}${tiersParam}${dateRangeQuery}`
    );
    const data = await response.json();
    return transform(data);
  }
}

type Availability = {
  available: string[];
};

function transform(response: V1GetSubscriptionAvailabilitiesResponse): Availability {
  const result: Availability = {
    available: [],
  };

  const body = response.body;

  Object.keys(body).forEach((styleCode) => {
    Object.entries(body[styleCode]).forEach(([productCode, availability]) => {
      if (availability["is_available_now"]) {
        result.available.push(productCode);
      }
    });
  });
  return result;
}
